import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeletePlaylistFolderDocument } from './delete.generated';

export const useDeletePlaylistFolder = (
  options: ApiOptions<typeof DeletePlaylistFolderDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(DeletePlaylistFolderDocument, {
    ...useNotifications(DeletePlaylistFolderDocument, {
      failure: (error) => error.message || t('api.playlist_folders.delete_error'),
      success: t('api.playlist_folders.delete_success'),
    }),
    ...options,
  });
};
